import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Link } from "react-router-dom";
import { Queries, Mutations } from "../../../../../graphql";
import PropTypes from "prop-types";
import {
  Tabs,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  message,
  Table,
  Icon,
  Button,
  Popconfirm,
  Form,
  Select,
  Radio,
  DatePicker,
  Avatar,
  Modal,
  InputNumber,
  TimePicker,
} from "antd";
import moment from "moment";
import FromInput from "../../../../../components/user/from/Input";
import {
  changeFormatdate,
  changeFormatFulldate,
} from "../../../../../utils/formatdate";
import { numberWithCommas } from "../../../../../utils/number";

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const DOCUMENT_TYPE = [
  { label: "ใบรับรองแพทย์", value: "ใบรับรองแพทย์" },
  //  { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
  { label: "อื่น ๆ", value: "อื่น ๆ" },
];

const newsDataProfile = "";
const format = "HH:mm";

class Tab2 extends Component {
  state = {
    dataTalbeUploads: [
      {
        documentType: null,
        description: null,
        attachFile: null,
        statusFile: false,
      },
    ],
    columns: [
      {
        title: "ลำดับ",
        dataIndex: "description",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyScholarship.studyScholarshipDetail[index].studyScholarshipDetailSort} */}
              {index + 1}
            </>
          );
        },
      },

      {
        title: "ชื่อทุน",
        dataIndex: "studyScholarshipDetailName",
        align: "center",
        vertical: "top",
        render: (item, record, index) => {
          return (
            <>
              {/* <Form.Item label={""} style={{ marginBottom: "0px" }}>
                <Select
                  style={{ width: "100%" }}
                  optionFilterProp="children"
                  disabled={true}
                  value={
                    this.props.detailForm?.studyScholarship
                      .studyScholarshipDetail[index].studyScholarshipDetailName
                  }
                ></Select>
              </Form.Item> */}
              {item}
            </>
          );
        },
      },
      {
        title: "แหล่งเงินทุน",
        dataIndex: "studyScholarshipDetailSource",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {console.log(
                "this.props.detailForm?.studyScholarship.studyScholarshipDetail[index].studyScholarshipDetailSource",
                this.props.detailForm?.studyScholarship.studyScholarshipDetail[
                  index
                ].studyScholarshipDetailSource
              )} */}
              {/* <FromInput
                disabled={true}
                value={
                  this.props.detailForm?.studyScholarship
                    .studyScholarshipDetail[index].studyScholarshipDetailSource
                }
                required={false}
                name={"studyScholarshipDetailSource"}
                mode={"text"}
              /> */}
              {item}
            </>
          );
        },
      },
      {
        title: "จำนวนเงินที่อนุมัติ (บาท)",
        dataIndex: "studyScholarshipDetailBenefit",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* <FromInput
                disabled={true}
                className="input-number"
                value={numberWithCommas(
                  this.props.detailForm?.studyScholarship
                    .studyScholarshipDetail[index].studyScholarshipDetailBenefit
                )}
                required={false}
                name={"name"}
                mode={"number"}
              /> */}
              {/* <InputNumber
                step={1000.01}
                min={0.0}
                disabled={true}
                formatter={(item) =>
                  `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(item) => item.replace(/\$\s?|(,*)/g, "")}
                value={this.props.detailForm?.studyScholarship.studyScholarshipDetail[index].studyScholarshipDetailBenefit}
                className="input-number"
              /> */}
              {numberWithCommas(item)}
            </>
          );
        },
      },
    ],
    dataTalbeLength: 1,
    preLoadOnsubmit: false,
  };

  dateFormatNumber = (values) => {
    let valueReturn = this.props.form.getFieldValue(values);
    return changeFormatdate(moment(valueReturn));
  };

  render() {
    const { match, detailForm } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { columns, preLoadOnsubmit, dataTalbeUploads } = this.state;

    console.log("detailForm Tab2", detailForm);

    return (
      <Row gutter={16} type="flex" justify="left" align="top">
        {console.log("detailForm Tab2.1", detailForm)}
        <Col xs={24} md={24} className="pt-0">
          <strong className="color-red">ข้อมูลทุน/สัญญา</strong>
        </Col>

        <Col xs={24} md={12} className="pt-2 mb-1">
          <FromInput
            disabled={true}
            value={detailForm?.studyScholarship.studyScholarContractNo ? detailForm?.studyScholarship.studyScholarContractNo : "-"}
            required={false}
            name={"name"}
            label="เลขที่สัญญา"
            mode={"text"}
          />
        </Col>

        
        <Col xs={24} md={12} className="pt-2 mb-1">
          {/* <Form.Item label={"วันที่ทำสัญญา"} className="mb-0">
            {getFieldDecorator("studyScholarContractSignDate", {
              initialValue: moment(
                detailForm?.studyScholarship.studyScholarContractSignDate
              ),
              // rules:  [{
              //    required:true,
              //    message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
              // }],
            })(
              <DatePicker
                format={this.dateFormatNumber("studyScholarContractSignDate")}
                placeholder=""
                style={{ width: "100%" }}
                disabled={true}
              />
            )}
          </Form.Item> */}
          <FromInput
                        disabled={true}
                        value={detailForm?.studyScholarship.studyScholarContractSignDate ? changeFormatdate(detailForm?.studyScholarship.studyScholarContractSignDate) : "-"}
                        required={false}
                        name={"studyLeaveDocumentDate"}
                        label="วันที่อนุมัติ"
                        mode={"text"}
                      />
        </Col>
<Col xs={24} md={12} className="pt-2 mb-1">
          <Form.Item label={"วันที่สร้างข้อมูล"} className="mb-0" hidden style={{height:"0px"}}>
            {getFieldDecorator("studyScholarContractDate", {
              initialValue: moment(
                detailForm?.studyScholarship.studyScholarContractDate
              ),
              // rules:  [{
              //    required:true,
              //    message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
              // }],
            })(
              <DatePicker
                format={this.dateFormatNumber("studyScholarContractDate")}
                placeholder=""
                style={{ width: "100%" }}
                disabled={true}
              />
            )}
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-2 mb-1">
          <Form.Item label={"ประเภทสัญญา"} hidden>
            {
              // getFieldDecorator("hospitalName", {
              //     initialValue: "",
              //     rules:  [{
              //         required: true,
              //         message: 'กรุณาระบุ ชื่อสถานพยาบาล',
              //     }],
              // })(
              <Select
                disabled={true}
                style={{ width: "100%" }}
                value={detailForm?.studyScholarship.studyScholarContractType}
                // onChange={ (e) => this.onChangeHospitalDetail(e) }
              ></Select>
              // )
            }
          </Form.Item>
        </Col>

       
        <Col xs={24} md={24} align={"right"} className="pt-4">
          <Table
            columns={columns}
            dataSource={detailForm?.studyScholarship.studyScholarshipDetail}
            pagination={false}
            className="mb-3"
            bordered
            rowCount={
              detailForm?.studyScholarship?.studyScholarshipDetail?.length
            }
            locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
            // pagination={{ pageSize: dataTalbeUploads.length }}
          />
        </Col>
      </Row>
    );
  }
}

Tab2.defaultProps = {
  autoFocus: false,
};

Tab2.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedTab2 = Form.create()(Tab2);

export default withApollo(WrappedTab2);
